import React from 'react';
import { IStore } from 'Store/.';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';
import { Dispatch, bindActionCreators } from 'redux';
import { DeliveryCode } from 'Store/Order/enums';
import { setSelectedDeliveryCode } from 'Store/Order/actions';
import { getDeliveryMethods, getSelectedDeliveryCode, getIsSkanetrafikenBooked } from 'Store/Order/selectors';
import PickDelivery from 'Components/PickDelivery/PickDelivery';
import WrapperBox from 'Components/Shared/WrapperBox/WrapperBox';

interface IPropsInternal {
  isSkanetrafikenBooked: boolean;
  selectedDeliveryCode: string;
  deliveryMethods: Julius.Website.DeliveryMethodViewModel[];
  setSelectedDeliveryCode: (deliveryCode: string) => void;
}

type Props = IPropsInternal;

class PickDeliveryContainer extends React.PureComponent<Props> {

  componentDidMount() {
    if (!this.props.selectedDeliveryCode) {
      this.setDefaultDeliveryMethod();
    }
  }

  componentWillReceiveProps(nextProps: Props) {
    const changeDelivery = 
      nextProps.isSkanetrafikenBooked && 
      !this.props.isSkanetrafikenBooked && 
      this.props.selectedDeliveryCode !== DeliveryCode.E_TICKET;

    if (changeDelivery) {
      this.props.setSelectedDeliveryCode(DeliveryCode.E_TICKET);
    }
  }

  setDefaultDeliveryMethod = () => {
    const { deliveryMethods } = this.props;

    if (deliveryMethods && deliveryMethods.length) {
      let defaultMethod = deliveryMethods.find(d => d.isDefault);

      if (!defaultMethod) {
        defaultMethod = deliveryMethods.find(d => d.code === DeliveryCode.E_TICKET);
      }
      if (!defaultMethod) {
        defaultMethod = deliveryMethods[0];
      }
      this.props.setSelectedDeliveryCode(defaultMethod.code);
    }
  }

  getDeliveryMethods = () => {
    const { isSkanetrafikenBooked, deliveryMethods } = this.props;

    if (!deliveryMethods) {
      return [];
    }
    if (!isSkanetrafikenBooked) {
      return deliveryMethods;
    }

    return deliveryMethods.filter(d => d.code === DeliveryCode.E_TICKET);
  }

  onDeliveryItemChange = (deliveryCode: string, isChecked: boolean) => {
    const code = isChecked ? deliveryCode : null;
    this.props.setSelectedDeliveryCode(code);
  }

  render() {

    const deliveryMethods = this.getDeliveryMethods();

    if (!deliveryMethods.length) {
      return null;
    }
    
    return (
      <WrapperBox>
        <PickDelivery
          deliveryMethods={ this.getDeliveryMethods() }
          selectedDeliveryCode={ this.props.selectedDeliveryCode }
          onDeliveryItemChange={ this.onDeliveryItemChange }
        />
      </WrapperBox>
    );
  }
}

const mapStateToProps = (state: IStore) => {
  return {
    deliveryMethods: getDeliveryMethods(state),
    selectedDeliveryCode: getSelectedDeliveryCode(state),
    isSkanetrafikenBooked: getIsSkanetrafikenBooked(state),
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => {
  return bindActionCreators({
    setSelectedDeliveryCode,
  }, dispatch);
};

export default compose<{}, {}>(
  withRouter,
  injectIntl,
  connect(mapStateToProps, mapDispatchToProps),
)(PickDeliveryContainer);


// WEBPACK FOOTER //
// ./src/components/PickDelivery/PickDeliveryContainer.tsx